import React from 'react';

export const SelectIcon = ({ 
  hasIcon, 
  iconPosition, 
  iconClass 
}) => {
  if (!hasIcon || iconPosition !== 'left') return null;

  return (
    <span className={`icon is-small is-${iconPosition}`}>
      <i className={iconClass}></i>
    </span>
  );
};